export const PATTERNS = {
  EMAIL:
    /^[\-a-z0-9~!$%^&*_=+\}\{'?]+(\.[\-a-z0-9~!$%^&*_=+\}\{'?]+)*@([a-z0-9_][\-a-z0-9_]*(\.[\-a-z0-9_]+)*\.([a-z]+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i,
  PHONE: /[0-9]{10}/,
  CONTAINS_NUMBER: /\d/,
  CONTAINS_LETTER: /[A-Za-z]/,
  CONTAINS_SPECIAL_CHARACTER: /\W/,
  US_PHONE_NUMBER:
    "^((\\([0-9]{3}\\)|[0-9]{3}[\\-\\| ]?)((?<![\\-\\| ])\\s)*[0-9]{3}[\\-\\| ]?[0-9]{4}|[0-9]{1,10})$", //10-digit phone number that might also have parentheses around the first 3 digits, along with either 1 hyphen, 1 space, or nothing between the remaining digits
};
